module.exports = __webpack_public_path__ + "img/home_image-logoquan@2x.3e89758e.png";